/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/


export enum PrintProofStatusEnum {
    "processing" = "processing",
    "pending_review" = "pending_review",
    "reviewed" = "reviewed"
}

export type PrintProofStatus = PrintProofStatusEnum;